import React, { forwardRef } from 'react';

const LABEL_STYLE = {
    color: '#000000',
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '1.33',
    marginBottom: '4px'
};

const TEXTAREA_STYLE = {
    background: '#fafbfc',
    border: '1px solid #b5cbeb',
    borderRadius: '8px',
    boxSizing: 'border-box',
    color: '#333333',
    fontSize: '14px',
    minHeight: '100px',
    outline: 'none',
    padding: '10px 12px',
    resize: 'vertical',
    width: '100%'
};

/**
 * Compatibility replacement for Atlaskit text areas.
 *
 * @param {Object} props - Component props.
 * @returns {React$Node}
 */
const TextAreaField = forwardRef(({
    autoFocus,
    className = '',
    defaultValue,
    disabled,
    id,
    isInvalid,
    label,
    maxLength,
    name,
    onBlur,
    onChange,
    onFocus,
    onKeyDown,
    onKeyPress,
    placeholder,
    readOnly,
    required,
    shouldFitContainer,
    value,
    ...rest
}, ref) => {
    const wrapperStyle = shouldFitContainer ? { width: '100%' } : undefined;
    const mergedStyle = {
        ...TEXTAREA_STYLE,
        ...isInvalid ? { borderColor: '#d83848',
            boxShadow: '0 0 0 1px #d83848' } : null
    };

    return (
        <div style = { wrapperStyle }>
            {label ? <label
                htmlFor = { id }
                style = { LABEL_STYLE }>{label}</label> : null}
            <textarea
                { ...rest }
                autoFocus = { autoFocus }
                className = { `input-control ${className}`.trim() }
                defaultValue = { defaultValue }
                disabled = { disabled }
                id = { id }
                maxLength = { maxLength }
                name = { name }
                onBlur = { onBlur }
                onChange = { onChange }
                onFocus = { onFocus }
                onKeyDown = { onKeyDown }
                onKeyPress = { onKeyPress }
                placeholder = { placeholder }
                readOnly = { readOnly }
                ref = { ref }
                required = { required }
                style = { mergedStyle }
                value = { value } />
        </div>
    );
});

export default TextAreaField;
